import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const departmentsAPI = createApi({
    reducerPath: 'departmentsAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        searchDepartments: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_DEPARTMENT_ACTION}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        listDepartments: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.DEPARTMENTS}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        newDepartment: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.NEW_DEPARTMENT,
                method: 'POST',
                data,
            }),
        }),
        modifyDepartment: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_DEPARTMENT,
                method: 'POST',
                data,
            }),
        }),
        newDepartmentAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.NEW_DEPARTMENT_ACTION,
                method: 'POST',
                data,
            }),
        }),
        modifyDepartmentAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_DEPARTMENT_ACTION,
                method: 'POST',
                data,
            }),
        }),
        deleteDepartment: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_DEPARTMENT,
                method: 'POST',
                data,
            }),
        }),
        viewDepartment: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.VIEW_DEPARTMENT,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useSearchDepartmentsMutation,
    useListDepartmentsMutation,
    useNewDepartmentMutation,
    useModifyDepartmentMutation,
    useNewDepartmentActionMutation,
    useModifyDepartmentActionMutation,
    useDeleteDepartmentMutation,
    useViewDepartmentMutation,
} = departmentsAPI;
